import { MerchantData } from '../types';

export const mapMerchantSession = (response: MerchantData) => ({
  displayName: response.display_name,
  domainName: response.domain_name,
  epochTimestamp: response.epoch_timestamp,
  expiresAt: response.expires_at,
  merchantIdentifier: response.merchant_identifier,
  merchantSessionIdentifier: response.merchant_session_identifier,
  nonce: response.nonce,
  operationalAnalyticsIdentifier: response.operational_analytics_identifier,
  pspId: response.psp_id,
  retries: response.retries,
  signature: response.signature,
});
